// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const PreviewPricing = ({ data, onEdit, onDelete }) => {
//   const handleCardClick = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (onEdit) {
//       onEdit("pricing", index);
//     }
//   };

//   const handleDelete = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (window.confirm("Are you sure you want to delete this pricing package?")) {
//       if (onDelete) {
//         onDelete("pricing", index);
//       }
//     }
//   };

//   return (
//     <Box onClick={(e) => e.stopPropagation()}>
//       <Typography
//         variant="caption"
//         color="text.secondary"
//         fontWeight={600}
//         display="block"
//         mb={1}
//       >
//         {data.sectionTitle}
//       </Typography>

//       {data.subheading && (
//         <Typography variant="body2" color="text.secondary" mb={2}>
//           {data.subheading}
//         </Typography>
//       )}

//       <Box display="flex" gap={2} flexWrap="wrap" mt={2}>
//         {data.packages.map((pkg, i) => (
//           <Box
//             key={i}
//             onClick={(e) => handleCardClick(i, e)}
//             sx={{
//               flex: "0 0 220px",
//               background: pkg.highlighted
//                 ? "rgba(59,130,246,0.1)"
//                 : "rgba(255,255,255,0.05)",
//               border: pkg.highlighted
//                 ? "2px solid #3b82f6"
//                 : "1px solid rgba(255,255,255,0.1)",
//               borderRadius: "10px",
//               p: 2,
//               cursor: "pointer",
//               transition: "all 0.2s",
//               position: "relative",
//               "&:hover": {
//                 background: pkg.highlighted
//                   ? "rgba(59,130,246,0.15)"
//                   : "rgba(255,255,255,0.08)",
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//               },
//             }}
//           >
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: 8,
//                 right: 8,
//                 display: "flex",
//                 gap: 0.5,
//               }}
//             >
//               <IconButton
//                 size="small"
//                 onClick={(e) => handleDelete(i, e)}
//                 sx={{
//                   width: 24,
//                   height: 24,
//                   background: "rgba(244,67,54,0.1)",
//                   color: "#f44336",
//                   "&:hover": {
//                     background: "rgba(244,67,54,0.2)",
//                   },
//                 }}
//               >
//                 <DeleteOutlineIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//               <IconButton
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleCardClick(i, e);
//                 }}
//                 sx={{
//                   width: 24,
//                   height: 24,
//                   background: "rgba(59,130,246,0.1)",
//                   color: "#3b82f6",
//                   "&:hover": {
//                     background: "rgba(59,130,246,0.2)",
//                   },
//                 }}
//               >
//                 <EditIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//             </Box>

//             <Box display="flex" flexDirection="column" gap={1}>
//               {/* Badge */}
//               {pkg.badge && (
//                 <Box
//                   sx={{
//                     display: "inline-block",
//                     background: "rgba(59,130,246,0.2)",
//                     color: "#3b82f6",
//                     fontSize: "9px",
//                     px: 1,
//                     py: 0.3,
//                     borderRadius: "4px",
//                     fontWeight: 600,
//                     width: "fit-content",
//                   }}
//                 >
//                   {pkg.badge}
//                 </Box>
//               )}

//               {/* Package Name */}
//               <Typography variant="subtitle2" fontWeight={600}>
//                 {pkg.name || "Package"}
//               </Typography>

//               {/* Price */}
//               <Typography variant="h6" fontWeight={700} color="#3b82f6">
//                 {pkg.price}
//               </Typography>

//               {/* Price Type */}
//               <Typography variant="caption" color="text.secondary">
//                 {pkg.priceType === "fixed" ? "Fixed Price" : "Custom Quote"}
//               </Typography>

//               {/* Features Count */}
//               <Typography variant="caption" color="text.secondary">
//                 {pkg.features?.length || 0} features included
//               </Typography>
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default PreviewPricing;


import React from "react";
import { Box, Typography } from "@mui/material";
import SummaryCard from "../shared/SummaryCard";

const PreviewPricing = ({ data, onEdit, onDelete }) => (
  <Box onClick={(e) => e.stopPropagation()}>
    {data.sectionTitle && (
      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={1}>
        {data.sectionTitle}
      </Typography>
    )}
    {data.subheading && (
      <Typography variant="body2" color="text.secondary" mb={2}>{data.subheading}</Typography>
    )}

    <Box display="flex" gap={2} flexWrap="wrap" mt={2}>
      {data.packages.length === 0 ? (
        <Typography variant="caption" color="text.secondary">No packages added yet</Typography>
      ) : (
        data.packages.map((pkg, i) => (
          <SummaryCard
            key={i}
            width={220}
            onClick={() => onEdit?.("pricing", i)}
            onDelete={() => onDelete?.("pricing", i)}
            highlighted={pkg.highlighted}
          >
            <Box display="flex" flexDirection="column" gap={1}>
              {pkg.badge && (
                <Box sx={{ display: "inline-block", background: "rgba(59,130,246,0.2)", color: "#3b82f6", fontSize: "9px", px: 1, py: 0.3, borderRadius: "4px", fontWeight: 600, width: "fit-content" }}>
                  {pkg.badge}
                </Box>
              )}
              <Typography variant="subtitle2" fontWeight={600}>{pkg.name || "Package"}</Typography>
              <Typography variant="h6" fontWeight={700} color="#3b82f6">{pkg.price}</Typography>
              {pkg.description && (
                <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic" }}>
                  {pkg.description}
                </Typography>
              )}
              <Typography variant="caption" color="text.secondary">
                {pkg.priceType === "fixed" ? "Fixed Price" : "Custom Quote"}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {pkg.features?.length || 0} features included
              </Typography>
            </Box>
          </SummaryCard>
        ))
      )}
    </Box>
  </Box>
);

export default PreviewPricing;